import Link from '@/models/Link'
import axios from 'axios'
import { ApiResponse } from './responses'

export interface LinkResponse extends ApiResponse {
  link: Link;
}

export default abstract class SubscriptionApi {
  static async access (token: string) {
    let response = await axios.get<LinkResponse>(`/access/${token}`)

    return response.data
  }
}
